<template>
  <v-card style="min-width: 400px">
    <v-toolbar
      class="white--text"
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title dense>Avanza Contenitore</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="red--text"
            @click="clickChiudi"
            color="blue-grey lighten-5"
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-row>
        <v-col>
          <div class="title mb-4">Scegli il tipo di contenitore</div>
          <v-row justify="center" align="center" class="ma-4">
            <h3 class="mr-3">SCANSIONA IL QR CODE</h3>
            <DataMatrixReader
              ref="qr"
              @clickChiudi="qr_attivo = false"
              v-on:detectQrCode="detectQrCode"
            />
          </v-row>
          <v-btn
            block
            class="mb-3 py-6 title"
            color="success"
            @click="clickContenitoreStandard"
            :disabled="pkg_std.id_articolo_packaging == null"
          >
            STANDARD ({{
              pkg_std.qta_contenitore == null
                ? "N/D"
                : `${pkg_std.qta_contenitore} pz`
            }})
          </v-btn>
          <v-btn
            block
            class="mb-3 py-6 title"
            color="primary"
            @click="clickContenitoreAlternativa"
          >
            ALTERNATIVA
          </v-btn>
          <v-btn
            block
            class="mb-3 py-6 title"
            color="secondary"
            @click="clickContenitoreLibera"
          >
            LIBERA
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog persistent v-model="quantita_alternativa_visible" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Q.tà Alternativa
              </v-toolbar-title>
            </v-col>
            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickSaveQuantitaAlternativa"
                    :disabled="!id_packaging_alternativo ? true : false"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="red--text"
                    @click="clickChiudiQuantitaAlternativa"
                    color="blue-grey lighten-5"
                    small
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="mt-5">
          <span style="font-size: 18px; color: black">
            Specificare la quantità dei contenitori e dei pezzi contenuti in
            ciascun contenitore.
          </span>
          <v-row align="center" class="mt-3" justify="center">
            <v-col align="center" cols="12">
              <div style="display: inline-block">
                <span style="color: black; font-size: 18px"
                  >Q.tà Contenitori:</span
                >
              </div>
              <div style="display: inline-block; margin-left: 10px">
                <v-text-field
                  class="centered-input"
                  label=""
                  min="1"
                  style="
                    display: inline-block;
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 35px;
                    max-width: 150px;
                    padding: 0px;
                  "
                  type="number"
                  v-model="num_contenitori"
                >
                </v-text-field>
              </div>
              <div class="mx-5" style="display: inline-block">
                <span style="color: black; font-size: 15px"><b>X</b></span>
              </div>
              <div style="display: inline-block">
                <v-select
                  dense
                  :items="opzioni_quantita_alternativa"
                  :item-text="
                    (e) => `${e.qta_contenitore} - ${e.des_contenitore}`
                  "
                  item-value="id_articolo_packaging"
                  label="Q.tà Pezzi"
                  style="font-weight: bold; width: 300px"
                  v-model="id_packaging_alternativo"
                >
                </v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="quantita_libera_visible" width="unset">
      <v-card style="min-width: 400px">
        <v-toolbar
          class="white--text"
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Q.tà Libera
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickSaveQuantitaLibera"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>

            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="red--text"
                    @click="clickChiudiQuantitaLibera"
                    color="blue-grey lighten-5"
                    small
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="mt-5">
          <span style="color: black; font-size: 18px">
            Definire il contenitore, la quantità di contenitori e di pezzi per
            contenitore:
          </span>
          <v-row class="mt-5">
            <v-col align="center" cols="12">
              <div class="mr-3" style="display: inline-block">
                <span style="color: black; font-size: 18px"> Contenitore </span>
              </div>
              <div class="mr-3" style="display: inline-block">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_contenitori_liberi"
                  item-text="cod_articolo"
                  item-value="id_articolo"
                  label="Contenitore"
                  outlined
                  style="border-radius: 0px"
                  v-model="id_contenitore_libero"
                ></v-autocomplete>
              </div>
              <div class="mr-3" style="display: inline-block">
                <span style="color: black; font-size: 18px">
                  Q.tà Contenitori
                </span>
              </div>
              <div style="display: inline-block">
                <v-text-field
                  class="centered-input"
                  hide-details
                  label=""
                  min="1"
                  style="
                    display: inline-block;
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 35px;
                    max-width: 150px;
                    padding: 0px;
                  "
                  type="number"
                  v-model="num_contenitori"
                >
                </v-text-field>
              </div>
              <div class="mx-3" style="display: inline-block">
                <span style="color: black; font-size: 18px">Q.tà pz. cad.</span>
              </div>
              <div style="display: inline-block">
                <v-text-field
                  class="centered-input"
                  hide-details
                  label=""
                  min="0"
                  style="
                    display: inline-block;
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 35px;
                    max-width: 150px;
                    padding: 0px;
                  "
                  type="number"
                  v-model="quantita_libera"
                >
                </v-text-field>
              </div>
              <div class="ml-5" style="display: inline-block">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_causali"
                  item-text="des"
                  item-value="id_tabella"
                  label="Causale"
                  outlined
                  style="border-radius: 0px"
                  v-model="id_causale_sel"
                ></v-autocomplete>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFERMA -->
    <v-dialog v-model="dialog_conferma_contenitore" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Q.tà Standard </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="confermaSalvataggio()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogConferma"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-0">
          <span style="color: black; font-size: 17px">
            Procedere alla registrazione dell'Avanzamento
            {{
              standard ? "Standard" : alternativa ? `Alternativo` : "Libero"
            }}
          </span>

          <div
            v-show="alternativa === true || libera === true"
            style="color: black; font-size: 17px"
          >
            <span>
              {{
                alternativa
                  ? `(${
                      parseInt(num_contenitori) *
                      opzioni_quantita_alternativa.filter(
                        (e) =>
                          e.id_articolo_packaging == id_packaging_alternativo
                      )[0].qta_contenitore
                    } unità nei contenitori)`
                  : libera
                  ? `(${(
                      parseInt(num_contenitori) * parseFloat(quantita_libera)
                    )
                      .toFixed(2)
                      .replace(".", ",")} unità nei contenitori)`
                  : ""
              }}</span
            >
          </div>

          <v-container v-if="standard">
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <div style="display: inline-block">
                  <span class="mr-3" style="color: black; font-size: 18px">
                    Q.tà Contenitori
                  </span>
                </div>
                <div style="display: inline-block">
                  <v-text-field
                    class="centered-input"
                    label=""
                    min="1"
                    style="
                      display: inline-block;
                      font-size: 30px;
                      font-weight: bold;
                      line-height: 35px;
                      max-width: 150px;
                      padding: 0px;
                    "
                    type="number"
                    v-model="num_contenitori"
                  >
                  </v-text-field>
                </div>
                <div style="display: inline-block">
                  <span class="mx-3" style="color: black; font-size: 15px"
                    ><b>X</b></span
                  >
                </div>
                <div style="display: inline-block">
                  <span style="color: black; font-size: 25px">{{
                    `${pkg_std.qta_contenitore} pz`
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import DataMatrixReader from "../../TOOLS/DataMatrixReader.vue";

class Qrcode {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      { nome: "check_seriale", default_val: null },
      { nome: "cod_articolo", default_val: null },
      { nome: "cod_packaging", default_val: "" },
      { nome: "quantita", default_val: null },
      { nome: "seriale", default_val: null },
      { nome: "tipo_etichetta", default_val: null },
    ];
    return campi;
  }
}

export default {
  name: "AvanzaContenitore",
  components: {
    SnackbarQV,
    DataMatrixReader,
  },
  props: ["workorder", "pkg_std", "opzioni_quantita_alternativa"],
  data() {
    return {
      // Variabili di supporto
      id_causale_sel: null,
      id_contenitore_libero: null,
      id_packaging_alternativo: null,
      num_contenitori: 1,
      quantita_libera: 0,
      qr_attivo: false,
      qr_code_sel: new Qrcode(),

      // Modal
      alternativa: false,
      dialog_conferma_contenitore: false,
      libera: false,
      quantita_alternativa_visible: false,
      quantita_libera_visible: false,
      standard: false,

      // Array
      items_causali: new Array(),
      items_contenitori_liberi: new Array(),
    };
  },
  methods: {
    confermaSalvataggio() {
      this.dialog_conferma_contenitore = false;
      if (this.standard === true) {
        if (this.num_contenitori <= 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "La quantità dei contenitori deve essere maggiore di 0."
          );
          return;
        }

        this.standard = false;
        this.$emit(
          "click_chiudi",
          "standard",
          this.pkg_std.id_articolo_packaging,
          this.workorder,
          this.pkg_std.qta_contenitore,
          this.num_contenitori
        );

        this.num_contenitori = 1;
      }

      if (this.alternativa === true) {
        if (this.num_contenitori <= 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "La quantità dei contenitori deve essere maggiore di 0."
          );
          return;
        }

        if (this.id_packaging_alternativo === null) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare la quantità di pezzi per contenitore."
          );
          return;
        }

        this.alternativa = false;
        this.$emit(
          "click_chiudi",
          "alternativa",
          this.id_packaging_alternativo,
          this.workorder,
          this.num_contenitori,
          this.opzioni_quantita_alternativa.filter(
            (e) => e.id_articolo_packaging == this.id_packaging_alternativo
          )[0].qta_contenitore
        );
        this.id_packaging_alternativo = null;
        this.num_contenitori = 1;
      }

      if (this.libera === true) {
        if (this.num_contenitori <= 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "La quantità dei contenitori deve essere maggiore di 0."
          );
          return;
        }

        if (this.quantita_libera <= 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare la quantità di pezzi per contenitore."
          );
          return;
        }

        this.libera = false;
        this.$emit(
          "click_chiudi",
          "libera",
          this.id_contenitore_libero,
          this.workorder,
          this.num_contenitori,
          this.quantita_libera,
          this.id_causale_sel,
        );
        this.num_contenitori = 1;
        this.quantita_libera = 0;
        this.id_contenitore_libero = null;
      }
    },
    clickContenitoreStandard() {
      /* Controllo che se il WO vuole prelievo componenti, la
       * registrazione non ecceda la quantità realizaabile. */
      if (
        this.num_contenitori * this.pkg_std.qta_contenitore >
          this.workorder.qta_realizzabile &&
        this.workorder.materia_prima === 1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${this.workorder.qta_realizzabile} unità). Dichiarare nuovi componenti.`
        );
        return;
      }

      this.dialog_conferma_contenitore = true;
      this.standard = true;
    },
    chiudiDialogConferma() {
      this.dialog_conferma_contenitore = false;
      this.standard = false;
      this.alternativa = false;
      this.id_packaging_alternativo = null;
      this.num_contenitori = 1;
      this.libera = false;
      this.quantita_libera = 0;
    },
    clickContenitoreAlternativa() {
      /* Se non ci sono packaging alternativi non mostro la
       * finestra di dialogo con cui preparare la registrazione. */
      if (this.opzioni_quantita_alternativa.length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non sono stati trovati packaging alternativi per questo articolo."
        );
      }

      if (this.opzioni_quantita_alternativa.length === 1) {
        this.id_packaging_alternativo =
          this.opzioni_quantita_alternativa[0].id_articolo_packaging;
      }

      this.quantita_alternativa_visible = true;
    },
    clickContenitoreLibera() {
      this.quantita_libera_visible = true;
    },
    clickChiudiQuantitaAlternativa() {
      this.quantita_alternativa_visible = false;
      this.id_packaging_alternativo = null;
      this.num_contenitori = 1;
    },
    clickChiudiQuantitaLibera() {
      this.quantita_libera_visible = false;
      this.id_contenitore_libero = null;
      this.num_contenitori = 1;
      this.quantita_libera = 0;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickSave() {
      this.$emit("click_save");
    },
    clickSaveQuantitaAlternativa() {
      /* Controllo che se il WO vuole prelievo componenti, la
       * registrazione non ecceda la quantità realizaabile. */
      if (
        parseInt(this.num_contenitori) *
          this.opzioni_quantita_alternativa.filter(
            (e) => e.id_articolo_packaging == this.id_packaging_alternativo
          )[0].qta_contenitore >
          this.workorder.qta_realizzabile &&
        this.workorder.materia_prima === 1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${this.workorder.qta_realizzabile} unità). Dichiarare nuovi componenti.`
        );
        return;
      }

      this.dialog_conferma_contenitore = true;
      this.quantita_alternativa_visible = false;
      this.alternativa = true;
    },
    clickSaveQuantitaLibera() {
      /* Controllo che se il WO vuole prelievo componenti, la
       * registrazione non ecceda la quantità realizaabile. */
      if (
        this.num_contenitori * this.quantita_libera >
          this.workorder.qta_realizzabile &&
        this.workorder.materia_prima === 1
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${this.workorder.qta_realizzabile} unità). Dichiarare nuovi componenti.`
        );
        return;
      }

      this.quantita_libera_visible = false;
      this.dialog_conferma_contenitore = true;
      this.libera = true;
    },
    detectQrCode(arg) {
      if (arg.includes("GETQRC") === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme, impossibile acquisire i dati."
        );
        return;
      }
      if (arg.includes("(P)")) {
        this.qr_code_sel.cod_articolo = arg.split("(P)")[1].split(";")[0];
        if (this.qr_code_sel.cod_articolo != this.workorder.cod_articolo) {
          this.$refs.SnackbarQV.print("error", "Il QRCODE non è corretto.");
        }
      }
      if (arg.includes("(K)")) {
        this.qr_code_sel.cod_packaging = arg.split("(K)")[1].split(";")[0];
      }

      // Controllo che il codice contenga l'informazione di quantità.
      if (arg.includes("(Q)")) {
        this.qr_code_sel.quantita = arg.split("(Q)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessuna Quantità), impossibile acquisire i dati."
        );
        return;
      }

      // Controllo che il codice contenga il tipo etichetta.
      if (arg.includes("(T)")) {
        this.qr_code_sel.tipo_etichetta = arg.split("(T)")[1].split(";")[0];
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme (nessun Tipo Etichetta), impossibile acquisire i dati."
        );
        return;
      }

      if (arg.includes("(S)")) {
        this.qr_code_sel.seriale = arg.split("(S)")[1].split(";")[0];
        if (this.qr_code_sel.seriale != "") {
          this.caricamento = true;
          // chiamata che controlla il seriale
          let request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "checknumeroseriale",
              token: localStorage.user_token,
              seriale: this.qr_code_sel.seriale,
            },
          };
          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                this.caricamento = false;
                this.qr_code_sel.check_seriale =
                  res.data.result[0].seriale_valido;

                console.log("Result qrcode: ", this.qr_code_sel);
                this.qr_attivo = true;
                if (this.qr_code_sel.check_seriale == "true") {
                  this.avanzamentoQrcode(this.qr_code_sel);
                } else {
                  this.$refs.SnackbarQV.print(
                    "error",
                    `Il seriale risulta già usato da ${
                      res.data.result[0].nominativo
                    } in data ${this.formatData(res.data.result[0].data)}.`
                  );
                }
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Errore di comunicazione col server, non è stato possibile ottenere i dati."
                );
              }
            })
            .catch(() => {
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile ottenere i dati."
              );
            });
        }
      }
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    getPackaging() {
      // Resetto i packaging liberi.
      this.items_contenitori_liberi = new Array();

      // Cerco l'id_tipo dei contenitori
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "TIPOARTICOLO",
          filter: "val_txt='PACK'",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          /* Se ottendo degli identificativi li uso per estrarre i contenitori. */
          if (
            res.status === 200 &&
            res.data.filter((t) => (t.cod = "CONTENITORE")).length > 0
          ) {
            const request2 = {
              controller: "Magazzino",
              method: "POST",
              richiesta: {
                action: "getarticoli",
                token: localStorage.user_token,
                cod_articolo: "*",
                id_tipo: res.data.filter((t) => (t.cod = "CONTENITORE"))[0]
                  .id_tabella,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                if (res2.status === 200) {
                  // Popolo l'elenco dei contenitori.
                  res2.data.lista.forEach((a) => {
                    this.items_contenitori_liberi.push({
                      id_articolo: a.id_articolo,
                      cod_articolo: a.cod_articolo,
                    });
                  });
                } else {
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Errore di comunicazione col server, non  stato possibile salvare i dati."
                  );
                }
              })
              .catch((err) => {
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non  stato possibile salvare i dati."
                );
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getTabella() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "CAUSALI_MAGAZZINO_MOVIMENTI",
          filter: "validita = 1 AND ordine IS NOT NULL",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data && res.data.filter((e) => e.cod === "CAMPIO").length > 0) {
              this.items_causali = res.data;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async avanzamentoQrcode(arg) {
      this.caricamento = true;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: this.workorder.id_macchina,
          id_commessa_dettaglio: this.workorder.id_commessa_dettaglio,
          id_contenitore: this.opzioni_quantita_alternativa.filter(
            (e) => e.cod_articolo_packaging == arg.cod_packaging
          )[0].id_articolo_packaging,
          qta_contenitori: 1,
          qta_pezzi: this.qr_code_sel.quantita,
          seriale: arg.seriale,
          tipo_etichetta:
            this.qr_code_sel.tipo_etichetta === "MASTER"
              ? 0
              : this.qr_code_sel.tipo_etichetta === "SLAVE"
              ? 1
              : "",
          tipo_avanzamento: this.workorder.tipo_avanzamento,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Resetto il codice QR e chiudo il dialog.
          this.qr_code_sel = new Qrcode();
          this.$emit("registrato_qrcode");
        }
      });
    },
  },
  mounted() {
    this.getTabella();
    this.getPackaging();
  },
};
</script>
